<li
  class="footer-menu-item"
  [class.footer-menu-item--root]="root"
  [class.active]="active"
  [class.has-items]="!root && menuItem.items?.length > 0"
  [class.has-submenu]="rootHasSubMenu()"
>
  <button
    *ngIf="root"
    class="footer-menu-item__root--cta"
    [class.active]="active"
    (click)="toggle()"
  >
    {{ menuItem.label }}
  </button>
  <h3 *ngIf="root" class="footer-menu-item__root--heading">
    {{ menuItem.label }}
  </h3>

  <div class="footer-menu-item__content" [class.active]="!root || active">
    <div
      class="footer-menu-item__content-wrapper"
      [class.has-items]="!root && menuItem.items?.length > 0"
    >
      <p
        *ngIf="!root && !menuItem.link && !menuItem.action"
        class="footer-menu-item__label"
        [class.has-items]="!root && menuItem.items?.length > 0"
      >
        {{ menuItem.label }}
      </p>

      <a
        *ngIf="!root && menuItem.link"
        class="footer-menu-item__link"
        [class.has-items]="!root && menuItem.items?.length > 0"
        [href]="menuItem.link"
      >
        {{ menuItem.label }}
      </a>

      <button
        *ngIf="!root && menuItem.action"
        class="footer-menu-item__cta"
        [class.has-items]="!root && menuItem.items?.length > 0"
        (click)="menuItem.action()"
      >
        {{ menuItem.label }}
      </button>

      <ul *ngIf="menuItem.items?.length > 0" class="footer-menu-item__list" [class.active]="active">
        <footer-menu-item
          *ngFor="let item of menuItem.items"
          [menuItem]="item"
          [root]="false"
        ></footer-menu-item>
      </ul>
    </div>
  </div>
</li>
